import { render, staticRenderFns } from "./EventBoothDetailTable.vue?vue&type=template&id=8196476a"
import script from "./EventBoothDetailTable.vue?vue&type=script&lang=js"
export * from "./EventBoothDetailTable.vue?vue&type=script&lang=js"
import style0 from "./EventBoothDetailTable.vue?vue&type=style&index=0&id=8196476a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports